import type { ReactNode } from 'react';
import { HolderOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './RowControls.module.css';

interface RowControlsProps {
  onDelete?: () => void;
  dragHandleProps?: Record<string, unknown>;
  /** Optional extra buttons rendered alongside delete */
  children?: ReactNode;
  className?: string;
}

/**
 * Floating controls shown on hover over an editable row/group/section.
 * Renders a drag handle (if dragHandleProps provided) and a delete button.
 */
export function RowControls({
  onDelete,
  dragHandleProps,
  children,
  className,
}: RowControlsProps) {
  return (
    <span className={`${styles.controls} ${className ?? ''}`}>
      {dragHandleProps && (
        <button
          type="button"
          className={styles.handle}
          aria-label="Drag to reorder"
          tabIndex={-1}
          {...dragHandleProps}
        >
          <HolderOutlined />
        </button>
      )}
      {children}
      {onDelete && (
        <button
          type="button"
          className={styles.deleteButton}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          aria-label="Delete"
          tabIndex={-1}
        >
          <DeleteOutlined />
        </button>
      )}
    </span>
  );
}
